import { createRoot } from "react-dom/client";
import App from "./App.jsx";
import "./index.css";
import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: import.meta.env.VITE_APP_SENTRY_DSN,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      networkDetailAllowUrls: [
        import.meta.env.VITE_API_BASE_URL,
        window.location.origin,
      ],
      maskAllInputs: true,
      maskAllText: false,
    }),
  ],
  environment: import.meta.env.VITE_APP_SENTRY_ENVIRONMENT,
  tracesSampleRate: import.meta.env.VITE_APP_TRACES_SAMPLE_RATE,
  replaysSessionSampleRate: import.meta.env
    .VITE_APP_REPLAYS_SESSION_SAMPLE_RATE,
  replaysOnErrorSampleRate: import.meta.env
    .VITE_APP_REPLAYS_ON_ERROR_SAMPLE_RATE,
});

createRoot(document.getElementById("root")).render(<App />);
